export const TRANSLATIONS_ES = {
    // COMMON MESSAGES
    UNAUTHORIZED: "No autorizado",
    ERROR_NO_PERMISSION: "No tienes permiso",
    NOT_FOUND: "Servicio no encontrado",
    BAD_REQUEST: "Solicitud incorrecta",
    SERVICE_ERROR: "Error de servicio",
    NETWORK_ERROR: "Tienes problemas en tu conexión a Internet, verifícalo y vuelve a intentarlo.",
    MAINTENANCE_MODE:
        "Disculpa, estamos realizando una mejora en el sistema, hemos incorporando nuevas funcionalidades y unas actualizaciones de seguridad, danos unos minutos más para terminar. Pronto podrás disfrutar de ellas.",
    ERROR_INVALID_VERIFICATION_CODE: "Código de verificación invalido",
    ERROR_CODE_EXPIRED: "El código de verificación caducó",
    ERROR_CONTACT_NOT_FOUND: "Contacto no encontrado",
    ERROR_GEOLOCATION_UNKNOWN: "Ocurrió un error desconocido al intentar acceder a tu ubicación.",
    ERROR_GEOLOCATION_PERMISSION_DENIED: "Has denegado el acceso a tu ubicación. Por favor, permite el acceso para continuar.",
    ERROR_GEOLOCATION_POSITION_UNAVAILABLE: "Tu ubicación no está disponible. Por favor, verifica la configuración de tu dispositivo.",
    ERROR_GEOLOCATION_TIMEOUT: "La solicitud para acceder a tu ubicación ha expirado. Por favor, inténtalo de nuevo.",

    fieldRequired: "Este campo es obligatorio",
    fieldInvalid: "Valor no válido",

    SUCCESS_DOCUMENT_SHARED: "Documento compartido con éxito",

    CONFIRM_CLOSE_TICKET: "¿Estás seguro de que quieres cerrar este ticket? Esta acción no se puede deshacer.",
    CONFIRM_RESOLVE_TICKET: "¿Estás seguro de que quieres resolver este ticket? Esta acción no se puede deshacer.",

    // LAYOUT
    footer1: "legale.io es una empresa de Despapeliza Llc. 7345 W Sand Lake RD STE 210, OFC 6837, Orlando, FL, USA",
    footer2: "Todos los derechos reservados legale",
    treesSaved: "Son los árboles que se han salvado usando Legale",
    signout: "Salir",

    // LOGIN
    emailVerify: "Verificar correo electrónico",
    email: "Email",
    submit: "Enviar",
    sendCode: "Enviar código",
    iHaveCode: "Tengo codigo",
    verificationCode: "Código de verificación",
    enterCode: "Introduzca el código",
    verify: "Verificar",
    resendCode: "Reenviar codigo",

    // EXPLORER
    drive: "Drive",
    myDocuments: "Mis documentos",
    sharedDocuments: "Documentos compartidos",
    searchResult: "Resultado de búsqueda",
    paginationDescription: "Desde {{fromNumber}} hasta {{toNumber}} (Total {{totalNumber}})",
    loadMore: "Carga más",
    user: "Usuario",
    document: "Documento",
    description: "Descripción",
    date: "Fecha",
    noData: "Sin datos",
    attachedFile: "Archivo adjunto",
    file: "Expediente",
    view: "Ver",
    download: "Descargar",
    filePreviewNotSupport: "La vista previa del archivo `{{fileName}}` no es compatible, descárguelo para verlo.",
    share: "Compartir",
    verification: "Verificación",
    workflowInformation: "Información del Workflow",
    flux: "Flujo",
    flux_priority: "Por prioridad",
    flux_simultaneously: "Simultáneamente",
    method: "Método",
    rejectedByUser: "Este usuario rechazó el documento",
    startedAt: "Empezó a las",
    openedAt: "Abierto a las",
    signedAt: "Firmado en",
    approvedAt: "Aprobado en",
    rejectedAt: "Rechazado en",
    pausedAt: "Pausado en",
    signLink: "URL de la firma",
    signStatus: "Aprobar / Firmar estado",
    signMethod: "Método de signos",
    signFlowStatus0: "NO FIRMADO",
    signFlowStatus1: "EN CURSO",
    signFlowStatus2: "FIRMADO",
    signFlowStatus3: "RECHAZADO",
    signFlowStatus4: "PAUSADO",
    signFlowStatus5: "EN CURSO",
    signFlowStatus100: "APROBADO",
    copied: "Copiado",
    signing: "Firma",
    productName_document: "Documento",
    productName_subscription: "Suscripción",
    productName_no_sms: "Remota",
    productName_certification: "Certificado en la nube",
    productName_sms: "Remota SMS",
    productName_fea: "Firma avanzada remota",
    productName_bulk_sign: "Firma bulk",
    productName_video_validation: "Verificación de video",
    productName_selfie_validation: "Verificación de selfies",
    productName_id_validation: "Adjuntar identificación",
    productName_geolocation: "Geolocalización",
    productName_secondary_user: "Usuarios",
    productName_storage: "Almacenamiento",
    productName_approve: "Aprobar por correo electrónico",
    productName_approve_legale: "Aprobar por el usuario de Legale",
    productName_approve_api: "Aprobar",
    productName_email_pin: "Correo PIN",
    productName_fiema_sobre: "Firma de grupo",
    productName_tablet_device: "Dispositivo Legale móvil",
    productName_tablet_sign: "Firma Legale Móvil",
    productName_signbox: "Signbox",
    productName_local_certificate: "Certificado local",
    productName_stamp: "Stamp",
    productName_no_certification: "Definir por firmante",
    productName_signing_portal: "Portal de firma",
    productName_send_email: "Enviar correo electrónico",
    sign: "Firmar",
    signStatusNotSigned: "No firmado",
    signStatusSigned: "Firmado",
    signStatusRejected: "Rechazado",
    signStatusReadyToSign: "Listo para firmar",
    signStatusWaitingForReview: "A la espera de revisión",
    inProcess: "En proceso",
    finished: "Finalizado",
    failed: "Fallido",
    stopped: "Interrumpido",
    search: "Buscar",
    startDate: "Fecha de inicio",
    endDate: "Fecha de término",
    all: "Todos",
    clear: "Limpiar",
    shareDocument: "Compartir documento",
    emails: "Correos electrónicos",
    remove: "Eliminar",

    upload: "subir",
    draw: "Dibujar",
    input: "Escribir",
    chooseSignMethod: "Elija el método de la firma",
    signatureImageDrawingTip: "No dibujes tu firma sobre el código QR",
    signatureImageDescription1: "Dibuja la imagen de tu firma sobre el cuadro",
    signatureImageDescription2:
        "Al firmar este documento con una firma electrónica, acepta que esta firma será tan válida como una firma manuscrita según las leyes locales.",
    signText: "Firmar texto",
    clearSignature: "Limpiar",
    signatureImage: "Imagen de firma",
    drawSignature: "Dibujar firma",
    fullName: "Nombre completo",
    uploadSignature: "Subir firma",
    deleteSignature: "Eliminar firma",
    localCertification: "Certificado local",
    usbToken: "Token USB",
    usbTokenDescription1: "Utilice un token de firma avanzado por puerto USB",
    usbTokenDescription2: "Para hacerlo, debe descargar el complemento haciendo clic en el botón de descarga",
    usbTokenDescription3: "Nota: solo es compatible con el sistema operativo Windows 10",
    geoLocation: "Geolocalización",
    geolocationDescription:
        "<span>La geolocalización se utiliza para dar cumplimiento de requisitos legales y regulatorios: En ciertos casos, las regulaciones o leyes pueden requerir la recolección de información de ubicación. Por ejemplo, en el caso de servicios financieros, puede ser necesario recopilar información de geolocalización para cumplir con las regulaciones de lucha contra el lavado de dinero o para prevenir fraudes. La verificación de la ubicación geográfica ayuda a asegurar que las transacciones o eventos se lleven a cabo dentro de los límites de un mismo país o estado, según lo requerido por las regulaciones pertinentes.</span><br><br><span>Nota: La base de datos utilizada para la geolocalización por IP puede contener errores o estar desactualizada. Esto puede resultar en información incorrecta o ubicaciones incorrectas asociadas con una dirección IP en particular.</span>",
    useGeoLocation: "Activar geolocalización",
    geolocationCheckboxDescription:
        "Acepto la <a href='https://legale.io/docs/use-and-processing-of-geolocation-data-in-legale-io/' target='_blank'>política de privacidad</a> y autorizo el uso de mi ubicación para determinar la jurisdicción notarial correspondiente.",
    noNumberToUseGeolocation:
        "No tienes monto para usar Geolocalización, por favor cómpralo primero en tienda o comunícate con tu ejecutivo.",
    SUCCESS_DOCUMENTS_SIGNED: "Documentos seleccionados firmados exitosamente.",
    FAIL_DOCUMENTS_SIGNED: "Error al firmar documentos seleccionados.",
    SUCCESS_BULK_SIGN: "Se han firmado exitosamente todos los {{successCount}} documentos seleccionados.",
    INFO_BULK_SIGN: "Se han firmado {{successCount}} de {{totalCount}} documentos seleccionados.",
    ERROR_BULK_SIGN: "Error al firmar documentos seleccionados.",
    geolocationNotAuthorized: "La geolocalización es requerida, necesitas autorizar el uso de la ubicación.",
    SIGN_METHODS_INVALID: "No es posible firmar varios documentos mediante firmas avanzadas. Por favor, seleccione un solo documento y vuelva a intentarlo.",
    SUCCESS_SIGN_TRIGGER: "El hilo de firmas se inició con éxito.",
    WARNING_FEA_BULK_SIGN: "No es posible firmar varios documentos mediante firmas avanzadas.",

    // DOCUMENT
    documentPreview: "Vista previa del documento",
    pdfPaginationDescription: "Página {{pageNumber}} de {{totalPage}}",

    // TICKET
    request: "Solicitud",
    tickets: "Tickets",
    myTickets: "Mis tickets",
    createTicket: "Crear ticket",
    subject: "Asunto",
    create: "Crear",
    ticket: "Ticket",
    chat: "Chat",
    viewHistory: "Ver historial",
    open: "Abierto",
    inProgress: "En progreso",
    resolved: "Resuelto",
    closed: "Cerrado",
    low: "Bajo",
    medium: "Medio",
    high: "Alto",
    urgent: "Urgente",
    status: "Estado",
    priority: "Prioridad",
    edit: "Editar",
    closeTicket: "Cerrar ticket",
    resolveTicket: "Resolver ticket",
    cancel: "Cancelar",
    save: "Guardar",
    resolve: "Resolver",
    close: "Cerrar",
    noTicketCreated: "No se ha creado ningún ticket",
    selectFileDescription:
        '<span>Puede arrastrar archivos como {{fileTypes}} para subirlos a legale <br> o <span class="color-blue">haga clic para seleccionarlos</span></span>',
    category: "Categoría",
    subCategory: "Subcategoría",
    editTemplate: "Editar plantilla",
    templateContent: "Contenido de la plantilla",
    name: "Nombre",
    callbackUrl: "URL de callback",
    content: "Contenido",
    formFields: "Campos del formulario",
    noFormFields: "Sin campos del formulario",
    unnamedField: "Campo sin nombre",
    portrait: "Vertical",
    landscape: "Horizontal",
    preview: "Vista previa",
    smartTemplateSaved: "Plantilla inteligente guardada correctamente",
    unsavedChangesTitle: "Tienes cambios sin guardar",
    unsavedChangesDescription:
        "Si sales de esta página ahora, se perderán tus cambios.\n¿Quieres guardar tu documento antes de salir?",
    discardChanges: "Descartar cambios",
    stayOnPage: "Quedarse en la página",
    saveAndLeave: "Guardar y salir",
    ERROR_SMART_TEMPLATE_FIELDS_REQUIRED: "Complete todos los campos obligatorios",
    home: "Inicio",
    versionControl: "Control de versiones",
    previewForm: "Vista previa del formulario",
    importFromDocx: "Importar desde DOCX",
    ai: "IA",
    addField: "Agregar campo",
    copyFieldNumber: "Copiar número de campo",
    copyIntoYourTemplate: "Copiar en tu plantilla",
    fieldConfiguration: "Configuración de campo",
    moveFieldUp: "Mover campo arriba",
    moveFieldDown: "Mover campo abajo",
    addFile: "Agregar archivo",
    fileConfiguration: "Configuración de archivo",
    moveFileUp: "Mover archivo arriba",
    moveFileDown: "Mover archivo abajo",
    attachedFiles: "Archivos adjuntos",
    watermark: "Marca de agua",
    opacity: "Opacidad",
    rotation: "Rotación",
    noAttachedFiles: "Sin archivos adjuntos",
    previewFormHelp: "Esta es una vista previa de los campos del formulario.",
    type: "Tipo",
    hidden: "Oculto",
    text: "Texto",
    fieldType_select: "Selección",
    number: "Número",
    time: "Hora",
    paragraph: "Párrafo",
    phone: "Teléfono",
    link: "Enlace",
    image: "Imagen",
    title: "Título",
    imagePreview: "Vista previa de imagen",
    fileLengthError: "La longitud máxima es de {{limit}} caracteres",
    yesNo: "Sí/No",
    currentDate: "Fecha actual",
    conditionalWord: "Palabra condicional",
    conditionalParagraph: "Párrafo condicional",
    multipleConditionalParagraph: "Párrafo condicional múltiple",
    takePhoto: "Tomar foto",
    conditionalImage: "Imagen condicional",
    answerSelection: "Selección de respuesta",
    answerSummary: "Resumen de respuestas",
    GUID: "GUID",
    userName: "Nombre de usuario",
    origin: "Origen",
    idNumber: "Número de ID",
    Folio: "Folio",
    documentCompliance: "Cumplimiento documental",
    itemGroup: "Grupo de ítems",
    isMultipleSelection: "Selección múltiple",
    conditionalVisible: "Visible condicionalmente",
    noFormat: "Sin formato",
    numberInWords: "número en palabras",
    NumberInWords: "Número en palabras",
    attachedToDocument: "Adjuntar al documento",
    createNewFile: "Crear nuevo archivo",
    warningSelectWithoutItem: "Agregue al menos un ítem seleccionable",
    inputSelectableItem: "Ítem seleccionable",
    add: "Agregar",
    groups: "Grupos",
    groupName: "Nombre del grupo",
    documentType: "Tipo de documento",
    warningWithoutDocumentTypes: "Agregue al menos un tipo de documento",
    warningWithoutGroups: "Agregue al menos un grupo",
    history: "Historia",
    comments: "Comentarios",
    draft: "Borrador",
    restoreThisVersion: "Restaurar esta versión",
    noComments: "Sin comentarios",
    addComment: "Agregar comentario",
    selectTextToComment: "Seleccione texto en el editor y agregue un comentario",
    SUCCESS_VERSION_RESTORED: "Versión restaurada correctamente",
    edited: "editado",
    reply: "Responder",
    justNow: "ahora",
    minAgo: "hace {{count}} min",
    minsAgo: "hace {{count}} mins",
    hourAgo: "hace {{count}} hora",
    hoursAgo: "hace {{count}} horas",
    dayAgo: "hace {{count}} día",
    daysAgo: "hace {{count}} días",
    CONFIRM_DELETE: "¿Estás seguro de eliminar?",
    review: "Revisión",
    delete: "Eliminar",
    lastUpdate: "Última actualización",
    no: "No",
    ticketDetail: "Detalle del ticket",
    backToTickets: "Volver a tickets",
    userInformation: "Información del usuario",
    contactInformation: "Información de contacto",
    noMessages: "No hay mensajes aún. ¡Inicia la conversación!",
    ok: "Aceptar",
    firstName: "Nombre",
    lastName1: "Apellido 1",
    lastName2: "Apellido 2",
    typeMessage: "Escribe un mensaje...",

    // MISC
    insert: "Insertar",
    format: "Formato",
    note: "Nota",
    selectFile: "Seleccione Archivo",
    selectUser: "Seleccionar usuario",

    // SMART TEMPLATE REVIEWS
    reviews: "Revisiones",
    accept: "Aceptar",
    reject: "Rechazar",
    feedback: "Comentario",
    revert: "Deshacer",
    acceptAll: "Aceptar todo",
    rejectAll: "Rechazar todo",
    complete: "Completo",
    noSuggestions: "Sin ediciones sugeridas",
    addFeedback: "Agregar feedback",
    addedParagraph: "Párrafo agregado",
    removedParagraph: "Párrafo eliminado",
    modifiedText: "Texto modificado",
    replacedTextWithText: "Texto reemplazado con texto",
};
